export var BoostPortalNavigationSteps;
(function (BoostPortalNavigationSteps) {
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["DEPARTMENT"] = 1] = "DEPARTMENT";
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["INFORMATION"] = 2] = "INFORMATION";
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["DIRECTDEBIT"] = 3] = "DIRECTDEBIT";
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["PAYMENT"] = 4] = "PAYMENT";
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["SUCCESS"] = 5] = "SUCCESS";
    BoostPortalNavigationSteps[BoostPortalNavigationSteps["SPONSOR"] = 6] = "SPONSOR";
})(BoostPortalNavigationSteps || (BoostPortalNavigationSteps = {}));
